"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentNoteType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AppointmentNoteType_Factory = /** @class */ (function () {
    function AppointmentNoteType_Factory() {
    }
    AppointmentNoteType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AppointmentNoteType1: model.AppointmentNoteType1,
            Description: model.Description,
        };
        return result;
    };
    AppointmentNoteType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AppointmentNoteType1: model.AppointmentNoteType1,
            Description: model.Description,
        };
        return result;
    };
    return AppointmentNoteType_Factory;
}());
exports.AppointmentNoteType_Factory = AppointmentNoteType_Factory;
